import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  meta: {},
  loaded: false,
  loading: false,
  error: null,
};

const events = createSlice({
  name: 'events',
  initialState,
  reducers: {
    getEventsRequest: (state) => {
      state.loading = true;
      state.loaded = false;
      state.payout = null;
    },
    getEventsSuccess: (state, { payload }) => {
      state.data = payload.data;
      state.meta = payload.meta || {};
      state.loading = false;
      state.loaded = true;
    },
    getEventsFailure: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
    deleteEventRequest: (state) => {
      state.loading = true;
      state.payout = null;
    },
    deleteEventSuccess: (state) => {
      state.loading = false;
    },
    deleteEventFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
    editEventRequest: (state) => {
      state.loading = true;
      state.payout = null;
    },
    editEventsuccess: (state) => {
      state.loading = false;
    },
    editEventFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
    duplicateEventRequest: (state) => {
      state.loading = true;
      state.payout = null;
    },
    duplicateEventSuccess: (state) => {
      state.loading = false;
    },
    duplicateEventFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
  },
});

export const { actions } = events;
export default events.reducer;
